import React from "react";
import { motion } from "framer-motion";

/**
 * BusImage - reusable hero illustration of a yellow Tata-style school bus.
 * Uses an AI-generated PNG (Gemini Nano Banana) stored in /public/buses/.
 *
 * props:
 *  - variant: which bus image to load (home | about | services | safety | tech | fleet)
 *  - className: optional extra classes
 */
const BUSES = {
  home: "/buses/bus-home.png",
  about: "/buses/bus-about.png",
  services: "/buses/bus-services.png",
  safety: "/buses/bus-safety.png",
  tech: "/buses/bus-tech.png",
  fleet: "/buses/bus-fleet.png",
};

const BusImage = ({ variant = "home", className = "" }) => {
  const src = BUSES[variant] || BUSES.home;

  return (
    <div
      className={`relative ${className}`}
      data-testid={`hero-bus-image-${variant}`}
    >
      <motion.img
        initial={{ opacity: 0, y: 20, scale: 0.98 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.9, ease: "easeOut" }}
        src={src}
        onError={(e) => {
          e.currentTarget.src = BUSES.home;
        }}
        alt="Yellow school bus"
        className="relative w-full h-auto object-contain rounded-2xl"
      />

      {/* Glowing route trail under the bus */}
      <svg
        viewBox="0 0 600 80"
        className="absolute -bottom-2 left-0 right-0 w-full h-12 pointer-events-none"
        aria-hidden
      >
        <defs>
          <linearGradient id="routeGrad" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#F5A524" stopOpacity="0" />
            <stop offset="40%" stopColor="#F5A524" stopOpacity="0.9" />
            <stop offset="100%" stopColor="#F5A524" stopOpacity="0" />
          </linearGradient>
        </defs>
        <path
          d="M20,55 C150,15 320,75 580,30"
          fill="none"
          stroke="url(#routeGrad)"
          strokeWidth="6"
          strokeLinecap="round"
          className="route-line"
        />
        <g transform="translate(540,18)">
          <circle r="9" fill="#2563EB" />
          <circle r="3" fill="#fff" />
        </g>
      </svg>
    </div>
  );
};

export default BusImage;
